import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AppMenu from './AppMenu';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { BarrioContext } from "./components/BarrioContext";
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { useTerminologia } from './hooks/useTerminologia';
import { ROL_SUPERADMIN, ROL_PERFIL_ADMINISTRADOR } from './constants/roles';

const fmtFecha = (fechaStr) => {
    if (!fechaStr) return '';
    return new Date(fechaStr).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const AppTopbar = (props) => {
    const { barrio, seleccionarBarrio } = useContext(BarrioContext);
    const t = useTerminologia();
    const toast       = useRef();
    const bellRef     = useRef(null);
    const pkgBellRef  = useRef(null);
    const HOST_API    = process.env.REACT_APP_URL;
    const navigate    = useNavigate();

    const rolId_local      = parseInt(localStorage.getItem('rolId') || '1');
    const esUsuarioBarrio  = rolId_local !== 1 && rolId_local !== ROL_SUPERADMIN && rolId_local !== ROL_PERFIL_ADMINISTRADOR;
    const esResidente      = rolId_local === 2;
    const administracionId = parseInt(localStorage.getItem('administracionId') || '1');
    const administracionLogo = localStorage.getItem('administracionLogo') || 'expensas360.png';
    const usuarioId        = JSON.parse(localStorage.getItem('user') || '{}').id
                          || JSON.parse(localStorage.getItem('user') || '{}').usuarioId
                          || 0;

    const [barrios,        setBarrios]        = useState([]);
    const [reclamos,       setReclamos]        = useState([]);
    const [bellOpen,       setBellOpen]        = useState(false);
    const [paquetesPend,   setPaquetesPend]    = useState([]);
    const [pkgBellOpen,    setPkgBellOpen]     = useState(false);

    const reclamosPendientes  = reclamos.filter(r => r.estado === 'Pendiente').length;
    const reclamosPreview     = [...reclamos]
        .sort((a, b) => (a.estado === 'Pendiente' ? 0 : 1) - (b.estado === 'Pendiente' ? 0 : 1))
        .slice(0, 6);
    const RECLAMO_ESTADO_COLORS = {
        'Pendiente':       { bg: '#fffaeb', color: '#b54708', border: '#fedf89' },
        'En proceso':      { bg: '#eff8ff', color: '#1570ef', border: '#b2ddff' },
        'Solucionado':     { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5' },
        'No solucionado':  { bg: '#fef3f2', color: '#f04438', border: '#fecdca' },
    };
    const pkgPendientesCount  = paquetesPend.length;
    const pkgPreview          = paquetesPend.slice(0, 5);

    // ── Carga barrios (solo admin) ──
    useEffect(() => {
        if (esUsuarioBarrio) return;
        axios.get(`${HOST_API}api/barrios/getBarrios?barrioId=0&administracionId=${administracionId}`)
            .then(res => setBarrios(res.data))
            .catch(err => console.error('Error al obtener barrios:', err));
    }, []);

    // ── Carga reclamos cuando cambia el barrio ──
    useEffect(() => {
        if (esUsuarioBarrio || !barrio?.id) { setReclamos([]); return; }
        axios.get(`${HOST_API}api/reclamos/GetReclamos?administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(({ data }) => setReclamos(data))
            .catch(() => setReclamos([]));
    }, [barrio?.id, administracionId]);

    // ── Carga paquetes pendientes para residente ──
    useEffect(() => {
        if (!esResidente || !barrio?.id || !usuarioId) { setPaquetesPend([]); return; }
        axios.get(`${HOST_API}api/unidadesFuncionales/GetUFsByUsuario?usuarioId=${usuarioId}&barrioId=${barrio.id}`)
            .then(({ data: ufs }) => {
                if (!ufs.length) { setPaquetesPend([]); return; }
                const calls = ufs.map(uf =>
                    axios.get(`${HOST_API}api/paquetes/GetPaquetes?administracionId=${administracionId}&barrioId=${barrio.id}&unidadFuncionalId=${uf.unidadFuncionalId}&soloEntregados=false`)
                );
                Promise.all(calls)
                    .then(results => setPaquetesPend(results.flatMap(r => r.data)))
                    .catch(() => setPaquetesPend([]));
            })
            .catch(() => setPaquetesPend([]));
    }, [barrio?.id, esResidente, usuarioId]);

    // ── Cierra popovers al hacer click fuera ──
    useEffect(() => {
        if (!bellOpen) return;
        const handler = (e) => {
            if (bellRef.current && !bellRef.current.contains(e.target)) setBellOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [bellOpen]);

    useEffect(() => {
        if (!pkgBellOpen) return;
        const handler = (e) => {
            if (pkgBellRef.current && !pkgBellRef.current.contains(e.target)) setPkgBellOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [pkgBellOpen]);

    const showSuccess = (titulo, mensaje) => {
        toast.current.show({ severity: 'success', summary: titulo, detail: mensaje, life: 3000 });
    };

    const onTopbarSubItemClick = (event) => {
        event.preventDefault();
        showSuccess('Expensas360', 'Gracias por usar Expensas360.');
        setTimeout(() => navigate('/Login'), 1500);
    };

    const PerfilClick = (event) => {
        event.preventDefault();
        alert('Perfil...proximamente.');
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="layout-topbar">
                <div className="layout-topbar-left">
                    <button className="topbar-menu-button p-link" onClick={props.onMenuButtonClick}>
                        <i className="pi pi-bars"></i>
                    </button>
                    <button className="logo p-link" onClick={() => navigate('/')}>
                        <img src={`assets/layout/images/administradoras/${administracionLogo}`} alt="logo" />
                    </button>
                </div>

                <AppMenu
                    model={props.items}
                    menuMode={props.menuMode}
                    colorScheme={props.colorScheme}
                    menuActive={props.menuActive}
                    activeInlineProfile={props.activeInlineProfile}
                    onSidebarMouseOver={props.onSidebarMouseOver}
                    onSidebarMouseLeave={props.onSidebarMouseLeave}
                    toggleMenu={props.onToggleMenu}
                    onChangeActiveInlineMenu={props.onChangeActiveInlineMenu}
                    onMenuClick={props.onMenuClick}
                    onRootMenuItemClick={props.onRootMenuItemClick}
                    onMenuItemClick={props.onMenuItemClick}
                />

                <div className="layout-topbar-right">
                    <ul className="layout-topbar-right-items">

                        {/* Selector de barrio */}
                        <li>
                            <div className="navbar">
                                {esUsuarioBarrio ? (
                                    <span style={{ fontWeight: 600, color: '#1a3c5e', fontSize: '1rem', padding: '0 0.5rem' }}>
                                        {barrio.nombre || t.Barrio}
                                    </span>
                                ) : (
                                    <Dropdown
                                        value={barrio.id ? Number(barrio.id) : null}
                                        options={barrios}
                                        optionLabel="nombreBarrio"
                                        optionValue="barrioId"
                                        onChange={(e) => {
                                            const selected = barrios.find(b => b.barrioId === e.value);
                                            if (selected) seleccionarBarrio(selected.barrioId, selected.nombreBarrio, selected.cuit, selected.direccion, selected.razonSocial, selected.numeroCuenta, selected.cuentaBancaria, selected.tipoCuentaBancaria, selected.alias);
                                        }}
                                        placeholder={`Seleccionar ${t.barrio}`}
                                        className="p-inputtext-sm"
                                    />
                                )}
                            </div>
                        </li>

                        {/* Perfil */}
                        <li id="profile" className={classNames('profile-item', { 'active-topmenuitem': props.topbarMenuActive })}>
                            <button className="p-link" onClick={props.onTopbarItemClick}>
                                <img src="assets/layout/images/profile.png" alt="profile" />
                            </button>
                            <ul className="fadeInDown">
                                <li role="menuitem">
                                    <button className="p-link" onClick={PerfilClick}>
                                        <i className="pi pi-fw pi-user"></i>
                                        <span>Perfil</span>
                                    </button>
                                </li>
                                <li role="menuitem">
                                    <button className="p-link" onClick={onTopbarSubItemClick}>
                                        <i className="pi pi-fw pi-sign-out"></i>
                                        <span>Cerrar sesión</span>
                                    </button>
                                </li>
                            </ul>
                        </li>

                        {/* Campana de paquetes (solo residente rolId=2) */}
                        {esResidente && (
                            <li style={{ position: 'relative' }} ref={pkgBellRef}>
                                <button
                                    className="p-link"
                                    onClick={() => setPkgBellOpen(prev => !prev)}
                                    style={{ position: 'relative' }}
                                >
                                    <i className="topbar-icon pi pi-fw pi-inbox"></i>
                                    {pkgPendientesCount > 0 && (
                                        <span className="topbar-badge">
                                            {pkgPendientesCount > 99 ? '99+' : pkgPendientesCount}
                                        </span>
                                    )}
                                    <span className="topbar-item-name">Paquetes pendientes</span>
                                </button>

                                {pkgBellOpen && (
                                    <div style={{
                                        position:     'absolute',
                                        top:          '100%',
                                        right:        0,
                                        marginTop:    8,
                                        width:        340,
                                        background:   '#fff',
                                        border:       '1px solid #e4e7ec',
                                        borderRadius: 12,
                                        boxShadow:    '0 8px 24px rgba(0,0,0,0.12)',
                                        zIndex:       9999,
                                        overflow:     'hidden',
                                    }}>
                                        {/* Cabecera */}
                                        <div style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #f2f4f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 700, color: '#101828', fontSize: '0.9rem' }}>Paquetes</span>
                                            {pkgPendientesCount > 0 && (
                                                <span style={{ background: '#eff8ff', color: '#1570ef', border: '1px solid #b2ddff', fontSize: '0.72rem', fontWeight: 700, padding: '0.1rem 0.5rem', borderRadius: 99 }}>
                                                    {pkgPendientesCount} pendiente{pkgPendientesCount !== 1 ? 's' : ''}
                                                </span>
                                            )}
                                        </div>

                                        {/* Lista */}
                                        {pkgPreview.length === 0 ? (
                                            <div style={{ padding: '1.25rem 1rem', textAlign: 'center', color: '#98a2b3', fontSize: '0.85rem' }}>
                                                No hay paquetes pendientes
                                            </div>
                                        ) : (
                                            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                                                {pkgPreview.map(p => (
                                                    <li key={p.paqueteId} style={{
                                                        padding:      '0.65rem 1rem',
                                                        borderBottom: '1px solid #f9fafb',
                                                        borderLeft:   '3px solid #1570ef',
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem' }}>
                                                            <span style={{ fontWeight: 600, color: '#344054', fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {p.origenEnvio}
                                                            </span>
                                                            <span style={{ background: '#fffaeb', color: '#b54708', border: '1px solid #fedf89', fontSize: '0.68rem', fontWeight: 700, padding: '0.1rem 0.4rem', borderRadius: 99, flexShrink: 0 }}>
                                                                Pendiente
                                                            </span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.2rem' }}>
                                                            <span style={{ fontSize: '0.77rem', color: '#667085' }}>{p.destinatario}</span>
                                                            <span style={{ fontSize: '0.77rem', color: '#98a2b3' }}>{fmtFecha(p.fechaRecepcion)}</span>
                                                        </div>
                                                        {p.nroPedido && (
                                                            <p style={{ margin: '0.2rem 0 0', fontSize: '0.77rem', color: '#667085' }}>
                                                                Pedido: {p.nroPedido}
                                                            </p>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                        {/* Footer */}
                                        <div
                                            style={{ padding: '0.65rem 1rem', borderTop: '1px solid #f2f4f7', textAlign: 'center', cursor: 'pointer' }}
                                            onClick={() => { setPkgBellOpen(false); navigate('/misPaquetes'); }}
                                        >
                                            <span style={{ color: '#1570ef', fontWeight: 600, fontSize: '0.83rem' }}>
                                                Ver todos <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }} />
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                        {/* Campana de reclamos (solo admin) */}
                        {!esUsuarioBarrio && (
                            <li style={{ position: 'relative' }} ref={bellRef}>
                                <button
                                    className="p-link"
                                    onClick={() => setBellOpen(prev => !prev)}
                                    style={{ position: 'relative' }}
                                >
                                    <i className="topbar-icon pi pi-fw pi-bell"></i>
                                    {reclamosPendientes > 0 && (
                                        <span className="topbar-badge">
                                            {reclamosPendientes > 99 ? '99+' : reclamosPendientes}
                                        </span>
                                    )}
                                    <span className="topbar-item-name">Reclamos pendientes</span>
                                </button>

                                {/* Popover */}
                                {bellOpen && (
                                    <div style={{
                                        position:     'absolute',
                                        top:          '100%',
                                        right:        0,
                                        marginTop:    8,
                                        width:        340,
                                        background:   '#fff',
                                        border:       '1px solid #e4e7ec',
                                        borderRadius: 12,
                                        boxShadow:    '0 8px 24px rgba(0,0,0,0.12)',
                                        zIndex:       9999,
                                        overflow:     'hidden',
                                    }}>
                                        {/* Cabecera del popover */}
                                        <div style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #f2f4f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 700, color: '#101828', fontSize: '0.9rem' }}>Reclamos</span>
                                            {reclamosPendientes > 0 && (
                                                <span style={{ background: '#fef3f2', color: '#f04438', border: '1px solid #fecdca', fontSize: '0.72rem', fontWeight: 700, padding: '0.1rem 0.5rem', borderRadius: 99 }}>
                                                    {reclamosPendientes} pendiente{reclamosPendientes !== 1 ? 's' : ''}
                                                </span>
                                            )}
                                        </div>

                                        {/* Lista */}
                                        {reclamosPreview.length === 0 ? (
                                            <div style={{ padding: '1.25rem 1rem', textAlign: 'center', color: '#98a2b3', fontSize: '0.85rem' }}>
                                                No hay reclamos registrados
                                            </div>
                                        ) : (
                                            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                                                {reclamosPreview.map(r => {
                                                    const esCerrado = r.estado === 'Solucionado' || r.estado === 'No solucionado';
                                                    const s = RECLAMO_ESTADO_COLORS[r.estado] || RECLAMO_ESTADO_COLORS['Pendiente'];
                                                    return (
                                                    <li key={r.reclamoId} style={{
                                                        padding:       '0.65rem 1rem',
                                                        borderBottom:  '1px solid #f9fafb',
                                                        borderLeft:    `3px solid ${s.color}`,
                                                        background:    esCerrado ? '#fafafa' : '#fff',
                                                        opacity:       esCerrado ? 0.7 : 1,
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem' }}>
                                                            <span style={{ fontWeight: 600, color: '#344054', fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {r.tipoReclamoNombre}
                                                            </span>
                                                            <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}`, fontSize: '0.68rem', fontWeight: 700, padding: '0.1rem 0.4rem', borderRadius: 99, flexShrink: 0 }}>{r.estado}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.2rem' }}>
                                                            <span style={{ fontSize: '0.77rem', color: '#667085' }}>{r.solicitante}</span>
                                                            <span style={{ fontSize: '0.77rem', color: '#98a2b3' }}>{fmtFecha(r.fecha)}</span>
                                                        </div>
                                                        {r.descripcion && (
                                                            <p style={{ margin: '0.2rem 0 0', fontSize: '0.77rem', color: '#667085', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {r.descripcion}
                                                            </p>
                                                        )}
                                                    </li>
                                                    );
                                                })}
                                            </ul>
                                        )}

                                        {/* Footer – Ver todos */}
                                        <div
                                            style={{ padding: '0.65rem 1rem', borderTop: '1px solid #f2f4f7', textAlign: 'center', cursor: 'pointer' }}
                                            onClick={() => { setBellOpen(false); navigate('/reclamosAdmin'); }}
                                        >
                                            <span style={{ color: '#1570ef', fontWeight: 600, fontSize: '0.83rem' }}>
                                                Ver todos <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }} />
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                    </ul>
                </div>
            </div>
        </>
    );
};

export default AppTopbar;
